import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import AppRouter from "./AppRouter";
import "./index.css";
import { AuthProvider } from "./pages/login/loginPage/AuthContext";
import { AuthProvider as DriverAuthProvider } from "./pages/zotSuivis/espaceChauffeur/auth"; 

ReactDOM.render(
  <Router>
    <AuthProvider>
      <DriverAuthProvider>
        <AppRouter />
      </DriverAuthProvider>
    </AuthProvider>
  </Router>,
  document.getElementById("root")
);
